<template>
  <svg width="12" height="4" viewBox="0 0 12 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.83757 3.16668C1.53757 3.16668 1.2209 3.03333 1.00423 2.81666C0.787565 2.59999 0.670898 2.30001 0.670898 2.00001C0.670898 1.70001 0.804232 1.40001 1.00423 1.16668C1.2209 0.95001 1.5209 0.833344 1.83757 0.833344C2.13757 0.833344 2.43757 0.966677 2.65424 1.16668C2.8709 1.38334 3.00423 1.68334 3.00423 2.00001C3.00423 2.30001 2.8709 2.59999 2.65424 2.81666C2.45424 3.04999 2.13757 3.16668 1.83757 3.16668ZM6.83757 2.81666C7.05423 2.59999 7.18756 2.30001 7.18756 2.00001C7.18756 1.70001 7.05423 1.40001 6.83757 1.16668C6.6209 0.95001 6.3209 0.833344 6.0209 0.833344C5.72089 0.833344 5.40423 0.966677 5.18756 1.16668C4.97089 1.38334 4.85423 1.68334 4.85423 2.00001C4.85423 2.30001 4.98756 2.59999 5.18756 2.81666C5.40423 3.03333 5.70423 3.16668 6.0209 3.16668C6.30423 3.16668 6.6209 3.04999 6.83757 2.81666ZM11.0042 2.81666C11.2209 2.59999 11.3542 2.30001 11.3542 2.00001C11.3542 1.70001 11.2209 1.40001 11.0042 1.16668C10.7876 0.95001 10.4876 0.833344 10.1876 0.833344C9.88756 0.833344 9.5709 0.966677 9.35423 1.16668C9.13756 1.38334 9.0209 1.68334 9.0209 2.00001C9.0209 2.30001 9.15423 2.59999 9.35423 2.81666C9.5709 3.03333 9.8709 3.16668 10.1876 3.16668C10.4709 3.16668 10.7876 3.04999 11.0042 2.81666Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'dotsIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      }
    }
  }
</script>
